import { gql } from "apollo-boost";

/* 담당자가 담당하는 회비 목록 */
export const MANAGER_FEE_LIST_QUERY = gql`
  query ManagerFeeList {
    ManagerFeeList {
      id
      title
      planner
      plannerUseSNS
      plannerSNS
      contents
      coverImg
      detailImg
      commonStatus
      createdAt
      manager {
        id
        name
        userId
      }
      trustlines {
        id
        currency
        amount
      }
    }
  }
`;

/* 담당 회비 1건 상세 (회비정보) */
export const MANAGER_FEE_DETAIL_QUERY = gql`
  query ManagerFeeDetail($id: String!) {
    ManagerFeeDetail(id: $id) {
      id
      title
      planner
      plannerUseSNS
      plannerSNS
      contents
      isDefault
      defaultRange
      coverImg
      detailImg
      commonStatus
      createdAt
      manager {
        id
        name
        userId
      }
      trustlines {
        id
        currency
        amount
      }
    }
  }
`;

/* 담당 회비 정보 수정 (담당자) */
export const MANAGER_FEE_EDIT_QUERY = gql`
  mutation ManagerFeeEdit(
    $id: String!
    $title: String
    $contents: String
    $planner: String
    $plannerUseSNS: String
    $plannerSNS: String
    $isDefault: String
    $defaultRange: Int
    $coverImg: CoverUpload
    $detailImg: DetailUpload
  ) {
    ManagerFeeEdit(
      id: $id
      title: $title
      contents: $contents
      planner: $planner
      plannerUseSNS: $plannerUseSNS
      plannerSNS: $plannerSNS
      isDefault: $isDefault
      defaultRange: $defaultRange
      coverImg: $coverImg
      detailImg: $detailImg
    )
  }
`;

/* 회비 회원 목록 */
export const MANAGER_FEEHASUSER_LIST_QUERY = gql`
  query ManagerFeeHasUserList($feeId: String!, $skip: Int, $first: Int) {
    ManagerFeeHasUserList(feeId: $feeId, skip: $skip, first: $first) {
      feeHasUsers {
        id
        commonStatus
        feeDay
        feeValue
        feeDefault
        feeAmount
        createdAt
        user {
          id
          name
          userId
          commonStatus
          confirmed
          blocked
        }
      }
      count
    }
  }
`;

/* 회비 회원 추가 대상(가용 회원) 검색 */
export const MANAGER_FEEHASUSER_EXCLUSIVE_QUERY = gql`
  query ManagerFeeHasUserExclusiveUserList($fee_id: String, $keyword: String) {
    ManagerFeeHasUserExclusiveUserList(
      fee_id: $fee_id
      keyword: $keyword
      orderBy: "id_DESC"
      first: 20
    ) {
      users {
        id
        name
        userId
      }
      count
    }
  }
`;

/* 회비 회원 추가 (등록 + 알림) */
export const MANAGER_FEEHASUSER_WRITE_QUERY = gql`
  mutation ManagerFeeHasUserWrite(
    $user_ids: [String!]
    $fee_id: String!
    $feeDay: String!
    $feeValue: String!
  ) {
    ManagerFeeHasUserWrite(
      user_ids: $user_ids
      fee_id: $fee_id
      feeDay: $feeDay
      feeValue: $feeValue
    )
  }
`;

/* 회비 회원 삭제 */
export const MANAGER_FEEHASUSER_DELETE_QUERY = gql`
  mutation ManagerFeeHasUserDelete($id: String!) {
    ManagerFeeHasUserDelete(id: $id)
  }
`;

/* 회비 회원 납부 정보 수정 */
export const MANAGER_FEEHASUSER_EDIT_QUERY = gql`
  mutation ManagerFeeHasUserEdit(
    $id: String!
    $feeDay: Int
    $feeValue: Int
    $feeDefault: Int
  ) {
    ManagerFeeHasUserEdit(
      id: $id
      feeDay: $feeDay
      feeValue: $feeValue
      feeDefault: $feeDefault
    )
  }
`;

/* 회비별 주민번호 수집 폼 토큰 발급/조회 */
export const MANAGER_FEE_TAX_FORM_TOKEN = gql`
  mutation ManagerFeeTaxFormToken($feeId: String!) {
    ManagerFeeTaxFormToken(feeId: $feeId)
  }
`;

/* 주민번호 제출 현황 + 수동 등록/삭제 (담당자) */
export const MANAGER_FEE_TAX_INFO_LIST_QUERY = gql`
  query ManagerFeeTaxInfoList($feeId: String!) {
    ManagerFeeTaxInfoList(feeId: $feeId) {
      id
      name
      phone
      residentNumber
      createdAt
    }
  }
`;
export const MANAGER_FEE_TAX_INFO_CREATE_QUERY = gql`
  mutation ManagerFeeTaxInfoCreate(
    $feeId: String!
    $name: String!
    $residentNumber: String!
    $phone: String!
  ) {
    ManagerFeeTaxInfoCreate(
      feeId: $feeId
      name: $name
      residentNumber: $residentNumber
      phone: $phone
    )
  }
`;
export const MANAGER_FEE_TAX_INFO_DELETE_QUERY = gql`
  mutation ManagerFeeTaxInfoDelete($id: String!) {
    ManagerFeeTaxInfoDelete(id: $id)
  }
`;

/* 회원 납부내역 */
export const MANAGER_FEEHASUSER_DETAIL_LIST_QUERY = gql`
  query ManagerFeeHasUserDetailList(
    $feeHasUser_id: String!
    $skip: Int
    $first: Int
  ) {
    ManagerFeeHasUserDetailList(
      feeHasUser_id: $feeHasUser_id
      skip: $skip
      first: $first
    ) {
      feeHasUserDetails {
        id
        description
        feeValue
        feeDefault
        feeAmount
        createdAt
      }
      count
    }
  }
`;

/* 회비 월별 거래(납부) 건수 — 셀렉트박스용 */
export const MANAGER_FEE_LEDGER_MONTHLY_COUNT_QUERY = gql`
  query ManagerFeeLedgerMonthlyCount($feeId: String!) {
    ManagerFeeLedgerMonthlyCount(feeId: $feeId) {
      year
      month
      count
    }
  }
`;

/* 회비 거래내역(원장) — 기간검색 + 페이징 */
export const MANAGER_FEE_LEDGER_LIST_QUERY = gql`
  query ManagerFeeLedgerList(
    $feeId: String!
    $year: Int
    $month: Int
    $skip: Int
    $first: Int
  ) {
    ManagerFeeLedgerList(
      feeId: $feeId
      year: $year
      month: $month
      skip: $skip
      first: $first
    ) {
      ledgers {
        id
        transactionType
        title
        value
        amount
        createdAt
      }
      count
    }
  }
`;

/* ===== 기부(Donation) 담당 ===== */

/* 담당자 송금(인출) — 담당 회비 잔액을 본인 지갑으로 (서버에서 본인 고정) */
export const MANAGER_FEE_TRUSTLINE_REMITTANCE = gql`
  mutation ManagerFeeTrustlineRemittance($feeId: String!, $value: String!) {
    ManagerFeeTrustlineRemittance(feeId: $feeId, value: $value)
  }
`;

/* 담당 기부 목록 */
export const MANAGER_DONATION_LIST_QUERY = gql`
  query ManagerDonationList {
    ManagerDonationList {
      id
      title
      contents
      planner
      plannerTel
      plannerUseSNS
      plannerSNS
      goalAmount
      startDate
      endDate
      detailImg
      totalDRM
      totalDNC
      commonStatus
      createdAt
      manager {
        id
        name
        userId
      }
    }
  }
`;

/* 담당 기부 1건 상세 */
export const MANAGER_DONATION_DETAIL_QUERY = gql`
  query ManagerDonationDetail($id: String!) {
    ManagerDonationDetail(id: $id) {
      id
      title
      contents
      planner
      plannerTel
      plannerUseSNS
      plannerSNS
      goalAmount
      startDate
      endDate
      coverImg
      detailImg
      totalDRM
      totalDNC
      createdAt
    }
  }
`;

/* 담당 기부 정보 수정 (담당자) */
export const MANAGER_DONATION_EDIT_QUERY = gql`
  mutation ManagerDonationEdit(
    $id: String!
    $title: String
    $contents: String
    $planner: String
    $plannerTel: String
    $plannerUseSNS: String
    $plannerSNS: String
    $goalAmount: Int
    $startDate: String
    $endDate: String
    $coverImg: CoverUpload
    $detailImg: DetailUpload
  ) {
    ManagerDonationEdit(
      id: $id
      title: $title
      contents: $contents
      planner: $planner
      plannerTel: $plannerTel
      plannerUseSNS: $plannerUseSNS
      plannerSNS: $plannerSNS
      goalAmount: $goalAmount
      startDate: $startDate
      endDate: $endDate
      coverImg: $coverImg
      detailImg: $detailImg
    )
  }
`;

/* 기부 내역(원장) — 기간검색 + 페이징 */
export const MANAGER_DONATION_LEDGER_LIST_QUERY = gql`
  query ManagerDonationLedgerList(
    $donationId: String!
    $year: Int
    $month: Int
    $skip: Int
    $first: Int
  ) {
    ManagerDonationLedgerList(
      donationId: $donationId
      year: $year
      month: $month
      skip: $skip
      first: $first
    ) {
      ledgers {
        id
        transactionType
        title
        currency
        value
        amount
        createdAt
      }
      count
    }
  }
`;

/* 기부 수집링크 토큰 발급 */
export const MANAGER_DONATION_TAX_FORM_TOKEN = gql`
  mutation ManagerDonationTaxFormToken($donationId: String!) {
    ManagerDonationTaxFormToken(donationId: $donationId)
  }
`;

/* 기부 주민번호 제출 현황 + 수동 등록/삭제 (담당자) */
export const MANAGER_DONATION_TAX_INFO_LIST_QUERY = gql`
  query ManagerDonationTaxInfoList($donationId: String!) {
    ManagerDonationTaxInfoList(donationId: $donationId) {
      id
      name
      phone
      residentNumber
      createdAt
    }
  }
`;
export const MANAGER_DONATION_TAX_INFO_CREATE_QUERY = gql`
  mutation ManagerDonationTaxInfoCreate(
    $donationId: String!
    $name: String!
    $residentNumber: String!
    $phone: String!
  ) {
    ManagerDonationTaxInfoCreate(
      donationId: $donationId
      name: $name
      residentNumber: $residentNumber
      phone: $phone
    )
  }
`;
export const MANAGER_DONATION_TAX_INFO_DELETE_QUERY = gql`
  mutation ManagerDonationTaxInfoDelete($id: String!) {
    ManagerDonationTaxInfoDelete(id: $id)
  }
`;
